/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SourceContactTag } from './SourceContactTag';
import {
    SourceContactTagFromJSON,
    SourceContactTagFromJSONTyped,
    SourceContactTagToJSON,
} from './SourceContactTag';

/**
 * 
 * @export
 * @interface FindAllSourceContactTags200Response
 */
export interface FindAllSourceContactTags200Response {
    /**
     * 
     * @type {Array<SourceContactTag>}
     * @memberof FindAllSourceContactTags200Response
     */
    data?: Array<SourceContactTag>;
}

/**
 * Check if a given object implements the FindAllSourceContactTags200Response interface.
 */
export function instanceOfFindAllSourceContactTags200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllSourceContactTags200ResponseFromJSON(json: any): FindAllSourceContactTags200Response {
    return FindAllSourceContactTags200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceContactTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceContactTags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(SourceContactTagFromJSON)),
    };
}

export function FindAllSourceContactTags200ResponseToJSON(value?: FindAllSourceContactTags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(SourceContactTagToJSON)),
    };
}

